// DISTANCE ELEVATION
export const GET_DISTANCE_ELEVATION_LIST = '/distance_elevation/query';
export const GET_DISTANCE_ELEVATION = '/distance_elevation/';
export const POST_DISTANCE_ELEVATION = '/distance_elevation/';
export const PUT_DISTANCE_ELEVATION = '/distance_elevation/';
export const DELETE_DISTANCE_ELEVATION = '/distance_elevation/';
